"use client";

import { VENUE_TABS } from "@/@core/constants/venue-tabs";
import UserGroupIcon from "@heroicons/react/24/solid/UserGroupIcon";
import CrewCard from "@/components/views/venue-details/card/crew/CrewCard";

interface Props extends Venue.Detail {}

export default function VenueDetailTrainerList(props: Props) {
  return (
    <>
      {props.workers.length > 0 && (
        <div
          id={VENUE_TABS.CREW}
          className="flex flex-col mt-6 lg:max-w-[895px] border rounded-[32px] px-4 pt-4 pb-2 gap-4 h-full"
        >
          {/* Header Text Part */}
          <div className="flex items-center gap-2 w-full rounded-[16px] bg-stone-50 py-1.5 px-2">
            <UserGroupIcon className="size-5 text-primary" />
            <h2 className="font-bold text-sm">Ekip</h2>
            <div className="py-[2px] cursor-default px-[6px] text-xs bg-primary text-white font-[500] rounded-full">
              {props.workers.length}
            </div>
          </div>

          <div className="lg:grid grid-cols-2 gap-4 hidden pb-2">
            {props.workers.map((worker, index) => {
              return (
                <CrewCard
                  key={index}
                  {...worker}
                  job={{ ...worker.job, venue: { ...props } }}
                />
              );
            })}
          </div>

          <div className="flex lg:hidden items-center flex-col w-full gap-4">
            {props.workers.map((worker, index) => {
              return (
                <CrewCard
                  key={index}
                  {...worker}
                  job={{ ...worker.job, venue: { ...props } }}
                />
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
